import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import * as styles from './styles/styles.module.scss';
import useScreenLock from '../../../hooks/useScreenLock';

const Modal = ({ children, handleBackgroundClick, modalStyle }) => {
  const [isMounted, toggleIsMounted] = useScreenLock();

  const onClick = e => {
    // Prevent inner clicks from closing the modal
    if (e.target.id != 'modal') {
      return;
    }

    handleBackgroundClick(e);
  };

  return (
    <CSSTransition
      in={isMounted}
      classNames={{
        enterDone: styles.enterDone,
        exit: styles.exit
      }}
      timeout={0}
    >
      <div role="dialog" id="modal" key="modal" className={styles.modal} onClick={onClick} style={modalStyle}>
        {children}
      </div>
    </CSSTransition>
  );
};

Modal.defaultProps = {
  children: null,
  handleBackgroundClick: null
};

Modal.propTypes = {
  children: PropTypes.node,
  handleBackgroundClick: PropTypes.func
};

export default Modal;
